import React from "react";
import {
  Avatar,
  CssBaseline,
  Typography,
  Container,
  Box
} from "@mui/material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";

class Message extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Container component="main" maxWidth="md" sx={{ pt: 12 }}>
        <CssBaseline />
        <Box display="flex" flexDirection="column" alignItems="center">
          <Avatar sx={{ bgcolor: "primary.main", mb: 2 }}>
            <EmailOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h6" textAlign="center">
            {"Dette systemet er laget for medlemmer i TFF & YFF. Systemet brukes til innberetning av premietall og skadetall (spesielt for grønt kort korrespondenter). Dersom du jobber i et medlemsselskap, og mener du bør ha en bruker til systemet, ber vi om at du sender en e-post til "}
            <span style={{ color: "#4169E1" }}>tff@forsikringsdrift.no</span>
          </Typography>
        </Box>
      </Container>
    );
  }
}

export default Message;
